import {compact} from '@benchling/js-utils';

import {
  ProcessFlowchartRootNode,
  ProcessFlowchartTaskNode,
  ProcessFlowchartRouterNode,
} from 'processes/graph-builder-processes/flowchart-viz/ProcessFlowchartNodeDetailType';
import {
  ProcessGraphBuilderTaskNode,
  ProcessTaskSchemaForGraphBuilderValidation,
} from 'processes/graph-builder-processes/validation/ProcessGraphBuilderConstants';
import {canRouteToNode} from 'processes/modals/router-config/RouterConfigUtils';

import {ProcessInteractiveFlowchart, ProcessFlowchartInteractiveNode} from '../ProcessFlowchartVizConstants';
import convertProcessFlowchartNodesToGraphBuilderNodes from './convertProcessFlowchartNodesToGraphBuilderNodes';
import {isOutputNode, isRouterNode, isTaskNode} from './getNodeDetailsTypeForInteractiveNode';

/** Returns all task nodes that routerNode flows information into */
export default function getAvailableDownstreamTaskNodesForRouterNode(
  flowchart: ProcessInteractiveFlowchart,
  routerInputNode: ProcessFlowchartTaskNode | ProcessFlowchartRootNode,
  routerNode: ProcessFlowchartRouterNode,
  flowchartSchema: ProcessTaskSchemaForGraphBuilderValidation
): Array<ProcessGraphBuilderTaskNode> {
  const visited = new Set<ProcessFlowchartInteractiveNode>();
  const routerNodeOutboundNodes = [];
  const queue: Array<ProcessFlowchartInteractiveNode> = [];
  queue.push(routerNode);
  while (queue.length !== 0) {
    const currentNode = queue.shift() as ProcessFlowchartInteractiveNode;
    if (isRouterNode(currentNode) && !visited.has(currentNode)) {
      visited.add(currentNode);
      const outgoingEdges = flowchart.edges.filter(
        ({fromNodeClientId}) => fromNodeClientId === currentNode.clientId
      );
      const childNodes = compact(
        outgoingEdges.map(({toNodeClientId}) =>
          flowchart.nodes.find(({clientId}) => clientId === toNodeClientId)
        )
      );

      queue.push(...childNodes);
    } else if (isTaskNode(currentNode) || isOutputNode(currentNode)) {
      routerNodeOutboundNodes.push(currentNode);
    }
  }
  return convertProcessFlowchartNodesToGraphBuilderNodes(routerNodeOutboundNodes, flowchartSchema).filter(
    (node): node is ProcessGraphBuilderTaskNode => canRouteToNode(node)
  );
}
